import { geocodeByAddress } from 'react-places-autocomplete'
import { getRouteMap4D } from '../../model/common'

export function parseAddressArrayToLocationArray(addressArray, callback) {
    let promiseArray = []
    addressArray.map(address => {
        promiseArray.push(geocodeByAddress(address))
    })
    Promise.all(promiseArray).then((values) => {
        let locaionArray = []
        values.map(value => {
            locaionArray.push({
                lat: value[0].geometry.location.lat(),
                lng: value[0].geometry.location.lng()
            })
        })
        // For city featured, use lat, lng of dicstrict 1 of HCM
        for (let i = 0; i < addressArray.length; i++) {
            const address = addressArray[i];
            if (address === "Hồ Chí Minh") {
                locaionArray[i] = {
                    lat: 10.771905,
                    lng: 106.698264
                }
            }
        }
        callback(locaionArray)
    })

}

export function parseAddressToLocation(address, lat, lng, callback) {
    // For city featured, use lat, lng of dicstrict 1 of HCM
    if (address === "Hồ Chí Minh") {
        callback({
            lat: 10.771905,
            lng: 106.698264
        })
        return;
    }

    if (lat && lng) {
        callback({
            lat: lat,
            lng: lng
        })
        return;
    }
		


}

export function calculateDistance(locationArray, wdOneWay, callback) {
    if (locationArray.length === 1) return callback(0, 0, 0)

       
    const wpnts = []
    for (let i = 1; i < locationArray.length; i++) {
            const location = locationArray[i];
            wpnts.push(`${location.lat},${location.lng}`);
    }
    
    const points = wpnts.length > 0 ? wpnts.join(";") : ""
    const origin =  `${locationArray[0].lat},${locationArray[0].lng}`;
    const destination = `${locationArray[0].lat},${locationArray[0].lng}`;


   getRouteMap4D(origin, destination, points).then((response) => { 
        
        if (response.data.code === "ok") {
            let wdDistanceOW = 0
            const myroute = response.data.result.routes[0];
            for (let i = 0; i < myroute.legs.length - 1; i++) {
                    wdDistanceOW += myroute.legs[i].distance.value / 1000;
            }
            const wdDistanceBackOW = myroute.legs[myroute.legs.length - 1].distance.value / 1000

            return callback(
                    wdOneWay ? wdDistanceOW : (wdDistanceOW + wdDistanceBackOW),  //Main value
                    wdDistanceOW,
                    wdDistanceBackOW
            )
            
        }

    })    
    // let totalDistance = 0
    // let waypts = []
    // let distanceBackOW = 0
    // for (let i = 1; i < locationArray.length; i++) {
    //     const location = locationArray[i];
    //     waypts.push({
    //         location: `${location.lat},${location.lng}`,
    //         // stopover: true
    //     });
    // }
    // var directionsService = new window.google.maps.DirectionsService();
    // directionsService.route({
    //     origin: `${locationArray[0].lat},${locationArray[0].lng}`,
    //     destination: `${locationArray[0].lat},${locationArray[0].lng}`,
    //     waypoints: waypts,
    //     // optimizeWaypoints: true,
    //     travelMode: 'DRIVING'
    // }, function (response, status) {
    //     if (status === 'OK') {
    //         var myroute = response.routes[0];
          
    //         var legs = myroute.legs.length;

    //         for (var i = 0; i < legs; i++) {
    //             totalDistance += myroute.legs[i].distance.value;                                                                                                 
    //         }
            
    //         if(oneWay) { 
    //             totalDistance = totalDistance - myroute.legs[legs - 1].distance.value;
    //         }

    //         totalDistance = totalDistance / 1000;
    //         distanceBackOW = myroute.legs[legs - 1].distance.value / 1000;
    //         callback(totalDistance, distanceBackOW)
    //     }
    // })
}


export function parseWdLocations(wdLocations) {
    const addressArray = [], locationArray = []
    wdLocations = wdLocations.split(",")
    for (let i = 0; i < wdLocations.length; i++) {
        const tempArray = wdLocations[i].split("-")
        locationArray.push({ lat: parseFloat(tempArray[0]), lng: parseFloat(tempArray[1]) })
        addressArray.push(Buffer.from(tempArray[2], 'base64').toString())
    }
    return {
        addressArray,
        locationArray
    }
}

export function validateHourCityTour(startDatewd, endDatewd, minHourCT) { 
    let result = -1

    let rangeHour = (endDatewd - startDatewd) / 3600000

    if(rangeHour < minHourCT) { 
        result = minHourCT
    }

    return result

}

export function findLimitDistance(wdMinHour, distance) { 

    let res = wdMinHour.split(";");
    let tokens;
    let limitDistances;

    for(let i=0; i < res.length; i++) { 
        res[i] = res[i].split("-")
     
        limitDistances = res[i]
      
        if(limitDistances[0] <= distance && distance <= limitDistances[1]) { 
          tokens = limitDistances;
        }
    }
    return tokens
    
}

export function getMinHourFromLimitDistance(tokens, distance) { 
  
    let minHour = -1;

    for(let i =0; i < tokens.length; i++) { 
      
        let minDistance = parseInt(tokens[i]);
        let maxDistance = parseInt(tokens[++i]);
        let fixedMinHour = parseInt(tokens[++i]);
        let extraDistance = parseInt(tokens[++i]);

        if (extraDistance === 0) { 
            minHour =  fixedMinHour;
        } else { 
            minHour = fixedMinHour + (distance - minDistance) / extraDistance;
        }
        break;
    }
    
    return Math.ceil(minHour)
}

export function checkValidMinHour(startDatewd, endDatewd, minHour) { 
    let result = -1

    let rangeHour = (endDatewd - startDatewd) / 3600000

    if(rangeHour < minHour) { 
        result = minHour
		}	

    return result
}

export function validateWDMinHour(wdMinHour, distance, startDatewd, endDatewd) { 

    let tokens = findLimitDistance(wdMinHour, distance);
    let minHour = getMinHourFromLimitDistance(tokens, distance);
    let result = checkValidMinHour(startDatewd, endDatewd, minHour); 

    return result; 
}

export function initMap (wdOneWay, refs, locAddress, dragable, mapName, stype) {

        
        // Using Map4D Api 
      
        if (document.getElementsByClassName("mf-map4d")[0]) {
            document.getElementsByClassName("mf-map4d")[0].remove()
        }

        let icCircle =  `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#1b468d" stroke="white" stroke-width="1" /></svg>`; 
        let zoom = 16
        let centerLoc = {lat: locAddress[0].lat, lng: locAddress[0].lng}
     

        if (locAddress.length > 1 && mapName === '') {
            centerLoc = new window.map4d.CoordinateTransformer([{lat: locAddress[0].lat, lng: locAddress[0].lng}, {lat: locAddress[locAddress.length-1].lat, lng: locAddress[locAddress.length-1].lng}]).center
            zoom = 9
        } 

        let mapWD = new window.map4d.Map(refs.current, {
            center: centerLoc,
            zoom: zoom,
            controls: true
        })


        let directionsRender = new window.map4d.DirectionsRenderer({
            activeStrokeColor: '#ff00ff',
            activeOutlineWidth: 0,
            activeOutlineColor: '#000000',
            activeStrokeWidth: 1

        })


        if(locAddress.length > 1) {

            const wpnts = [];
            let waypointMarkerOptions = []
        
            for (let i = 1; i < locAddress.length; i++) {
                const location = locAddress[i];
                wpnts.push(`${location.lat},${location.lng}`);
                if (!wdOneWay) {
                    waypointMarkerOptions.push({
                        position: {lat: location.lat, lng: location.lng},
                        draggable: false,
                        visible: true,
                        iconView: icCircle,
                        anchor: [0.3, 0.5],
                    })
                }
            }
            
            
            const points = wpnts.length > 0 ? wpnts.join(";") : ""
            const origin =  `${locAddress[0].lat},${locAddress[0].lng}`;
            const destination = wdOneWay ? `${locAddress[locAddress.length-1].lat},${locAddress[locAddress.length-1].lng}` : `${locAddress[0].lat},${locAddress[0].lng}`;

            getRouteMap4D(origin, destination, points).then((response) => {

                if (response.data.code === "ok") {

                const legs = response.data.result.routes[0].legs
                const stLoc = response.data.result.routes[0].legs[0].startLocation
                let etLoc = response.data.result.routes[0].legs[[legs.length - 1]].endLocation

                directionsRender.setOptions({
                    routes: response.data,
                    originMarkerOptions: {
                        position: {lat: stLoc.lat, lng: stLoc.lng },
                        title: "Start",
                        draggable: false,
                        visible: true,
                        iconView: icCircle,
                        anchor: [0.25, 0.5],
                    },
                    destinationMarkerOptions: {
                        position: {lat: etLoc.lat, lng: etLoc.lng},
                        title: "End",
                        visible: true,
                        draggable: false,
                        iconView: icCircle,
                        anchor: [0.25, 0.5],
                        userInteractionEnabled: false
                    },
                    waypointMarkerOptions: waypointMarkerOptions,
                    activeStrokeColor: '#0080ff',
                    activeOutlineWidth: 0,
                    activeStrokeWidth: 2,
                    inactiveOutlineWidth: 0,

                })
                
                directionsRender.setMap(mapWD)
                }
    
            })
        
        
        } else { 


            directionsRender.setOptions({
                originMarkerOptions: {
                    position: {lat: locAddress[0].lat, lng: locAddress[0].lng },
                    title: "Start",
                    draggable: false,
                    visible: true,
                    iconView: icCircle,
                    anchor: [0.25, 0.5],
                },
                destinationMarkerOptions: {
                    position: {lat: locAddress[0].lat, lng: locAddress[0].lng},
                    title: "End",
                    visible: true,
                    draggable: false,
                    iconView: icCircle,
                    userInteractionEnabled: false,
                    anchor: [0.25, 0.5],
                },
            })
            
            directionsRender.setMap(mapWD)
    

        }
    
       
   
}



// WEBPACK FOOTER //
// ./src/components/common/wdfunction.js